import React from 'react';
import { BiSolidLockOpen as LockIcon } from 'react-icons/bi';
import { BsGearWideConnected as GearIcon, BsLightningChargeFill as LightningIcon } from 'react-icons/bs';
import { FaClock as ClockIcon, FaWrench as WrenchIcon } from 'react-icons/fa';
import { MdSensorDoor as DoorIcon } from 'react-icons/md';

import { Colors } from '../../utils/Colors';

import brochure from '../../assets/pdfDocuments/FR/mega/Brochure TECH-ROLL MEGA.pdf';
import specificationCD from '../../assets/pdfDocuments/FR/mega/Specification TECH-ROLL MEGA CD - INDOTECH.pdf';
import specificationDD from '../../assets/pdfDocuments/FR/mega/Specification TECH-ROLL MEGA DD - INDOTECH.pdf';
import bottomBarImg from '../../assets/pictures/components/bottomBar.svg';
import brakesImg from '../../assets/pictures/components/brakes.svg';
import curtainImg from '../../assets/pictures/components/curtain.svg';
import endlocksImg from '../../assets/pictures/components/endlocks.svg';
import guidesImg from '../../assets/pictures/components/guides.svg';
import operatorImg from '../../assets/pictures/components/operator.svg';
import springsImg from '../../assets/pictures/components/springs.svg';
import windbarsImg from '../../assets/pictures/components/windbars.svg';

export const megaPdfs = [
    { pdfTitle: 'products.mega.pdfs.brochure', pdfLink: { fr: brochure, en: brochure } },
    { pdfTitle: 'products.mega.pdfs.specificationCD', pdfLink: { fr: specificationCD, en: specificationCD } },
    { pdfTitle: 'products.mega.pdfs.specificationDD', pdfLink: { fr: specificationDD, en: specificationDD } },
];

export const megaInfoKeys = [
    'products.mega.infos.motor',
    'products.mega.infos.cce',
    'products.mega.infos.curtain',
    'products.mega.infos.guides',
    'products.mega.infos.springs',
    'products.mega.infos.springOptions',
    'products.mega.infos.bar',
    'products.mega.infos.safety',
];

export const megaBenefits = [
    {
        benefitKey: 'products.mega.benefits.downtime',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LightningIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.mega.benefits.energy',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <GearIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.mega.benefits.costRepair',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <WrenchIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.mega.benefits.maintenance',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <ClockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.mega.benefits.impact',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <DoorIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.mega.benefits.pricing',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
];

export const megaSpecificationKeys = [
    {
        label: 'specificationsLabel.cycles',
        value: 'products.mega.specificationsValues.cycles',
    },
    {
        label: 'specificationsLabel.drive_system',
        value: [
            {
                label: 'products.mega.specificationsValues.drive_system.chain_driven_operator',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.direct_drive_operator',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.integrated_brake_system',
                value: 'specificationSecondValues.electromagnetic',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.one_phase_208_to_240_volts',
                value: 'specificationSecondValues.unavailable',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.three_phase_208_to_575_volts',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.chain_hoist_for_manual_operation',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.speed_variator',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.mega.specificationsValues.drive_system.control_panel',
                value: 'specificationSecondValues.standard_with_vfd_plc',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain',
        value: [
            {
                label: 'products.mega.specificationsValues.curtain.sbr',
                value: 'specificationSecondValues.standard_black',
            },
            {
                label: 'products.mega.specificationsValues.curtain.thickness',
                value: 'specificationSecondValues.blue_curtain_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain_idler',
        value: 'products.mega.specificationsValues.curtain_idler',
    },
    {
        label: 'specificationsLabel.temperature',
        value: 'products.mega.specificationsValues.temperature',
    },
    {
        label: 'specificationsLabel.endlock_system',
        value: 'products.mega.specificationsValues.endlock_system',
    },
    {
        label: 'specificationsLabel.bottom_bar',
        value: 'products.mega.specificationsValues.bottom_bar',
    },
    {
        label: 'specificationsLabel.guide',
        value: 'products.mega.specificationsValues.guide',
    },
    {
        label: 'specificationsLabel.inertia_brake',
        value: 'products.mega.specificationsValues.inertia_brake',
    },
    {
        label: 'specificationsLabel.frame_color',
        value: [
            {
                label: 'products.mega.specificationsValues.frame_color.standard_yellow',
                value: 'specificationSecondValues.other_colors_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.safety',
        value: 'products.mega.specificationsValues.safety',
    },
    {
        label: 'specificationsLabel.mounting',
        value: [
            {
                label: 'products.mega.specificationsValues.mounting.concrete',
                value: 'products.mega.specificationsValues.mounting.steel',
            },
        ],
    },
    {
        label: 'specificationsLabel.balance_system',
        value: [
            {
                label: 'products.mega.specificationsValues.balance_system.springs',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.mega.specificationsValues.balance_system.counter_weight',
                value: 'specificationSecondValues.available_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.wind_bar',
        value: [
            {
                label: 'products.mega.specificationsValues.wind_bar.one',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.mega.specificationsValues.wind_bar.two',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.mega.specificationsValues.wind_bar.external',
                value: 'specificationSecondValues.available_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.options',
        value: [
            {
                label: 'products.mega.specificationsValues.options.windows',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.mega.specificationsValues.options.pneumatic_sensor',
                value: 'specificationSecondValues.reversing_edges',
            },
            {
                label: 'products.mega.specificationsValues.options.reflective_stripes',
                value: 'specificationSecondValues.yellow_and_gray',
            },
            {
                label: 'products.mega.specificationsValues.options.photocells',
                value: 'specificationSecondValues.available',
            },
        ],
    },
    {
        label: 'specificationsLabel.other_electric',
        value: 'products.mega.specificationsValues.other_electric',
    },
    {
        label: 'specificationsLabel.wind_res',
        value: 'products.mega.specificationsValues.wind_res',
    },
];

export const megaComponents = [
    {
        id: 'curtain',
        number: 1,
        title: 'products.mega.components.curtain.title',
        description: 'products.mega.components.curtain.description',
        img: curtainImg,
    },
    {
        id: 'endLocks',
        number: 2,
        title: 'products.mega.components.endLocks.title',
        description: 'products.mega.components.endLocks.description',
        img: endlocksImg,
    },
    {
        id: 'bottomBar',
        number: 3,
        title: 'products.mega.components.bottomBar.title',
        description: 'products.mega.components.bottomBar.description',
        img: bottomBarImg,
    },
    {
        id: 'guideRails',
        number: 4,
        title: 'products.mega.components.guideRails.title',
        description: 'products.mega.components.guideRails.description',
        img: guidesImg,
    },
    {
        id: 'windBars',
        number: 5,
        title: 'products.mega.components.windBars.title',
        description: 'products.mega.components.windBars.description',
        img: windbarsImg,
    },
    {
        id: 'springs',
        number: 6,
        title: 'products.mega.components.springs.title',
        description: 'products.mega.components.springs.description',
        img: springsImg,
    },
    {
        id: 'operators',
        number: 7,
        title: 'products.mega.components.operators.title',
        description: 'products.mega.components.operators.description',
        img: operatorImg,
    },
    {
        id: 'brakes',
        number: 8,
        title: 'products.mega.components.brakes.title',
        description: 'products.mega.components.brakes.description',
        img: brakesImg,
    },
];
